import { withLocale } from "../../l10n/index.jsx";

/**
 * Datos del modem Teltonika de un dispositivo, en solo lectura.
 */
function ModemInfo({ lang, data }) {
  if (!data?.imei) {
    return (
      <p className="p-3">
        {lang.handle('Este dispositivo no tiene ningún modem Teltonika asociado')}
      </p>
    );
  }

  const rows = [
    { label: 'IMEI', value: data.imei },
    { label: lang.handle('Tipo Teltonika'), value: data.modem_type_code },
    { label: lang.handle('Número de serie'), value: data.modem_serial_number },
    { label: 'MAC', value: data.modem_mac },
    { label: lang.handle('Contraseña del dispositivo'), value: data.modem_device_password },
  ];

  return (
    <div>
      {rows.map(row => (
        <div className="form-group row" key={row.label}>
          <label className="col-sm-2 col-form-label newCard-form-text"> {row.label} </label>
          <div className="col-sm-10">
            <input type="text" className="form-control" value={row.value ?? ''} disabled />
          </div>
        </div>
      ))}
    </div>
  );
}

export default withLocale(ModemInfo);
